import { useEffect } from 'react'

// Keep the existing Members overlay/navigation layout until a keyboard reduces
// the visual viewport. The shell owns its padding; the card must fit inside it.
export function useModalVisualViewport(shellRef, enabled = true) {
  useEffect(() => {
    const viewport = window.visualViewport
    const shell = shellRef.current
    if (!enabled || !viewport || !shell) return undefined
    const prior = { top: shell.style.top, height: shell.style.height, bottom: shell.style.bottom }
    let focusFrame
    const update = () => {
      const keyboardOpen = window.innerHeight - viewport.height > 120
      shell.toggleAttribute('data-keyboard-open', keyboardOpen)
      Object.assign(shell.style, keyboardOpen
        ? { top: `${viewport.offsetTop}px`, height: `${viewport.height}px`, bottom: 'auto' }
        : prior)
      cancelAnimationFrame(focusFrame)
      const focused = document.activeElement
      if (keyboardOpen && shell.contains(focused) && focused.matches('input,textarea,select')) {
        focusFrame = requestAnimationFrame(() => {
          if (focused.isConnected && document.activeElement === focused && focused.closest('[data-keyboard-open]') === shell) focused.scrollIntoView({ block: 'nearest' })
        })
      }
    }
    update()
    viewport.addEventListener('resize', update)
    viewport.addEventListener('scroll', update)
    return () => {
      cancelAnimationFrame(focusFrame)
      viewport.removeEventListener('resize', update)
      viewport.removeEventListener('scroll', update)
      shell.removeAttribute('data-keyboard-open')
      Object.assign(shell.style, prior)
    }
  }, [shellRef, enabled])
}
